import qs from 'qs';

import { BlockTypeResource } from '../../Block/Block';
import { PageDraftConfig } from '../../Page/Page';

// TODO: Find more permanent name/fix for this populate solution
export const strapiBlockPopulates = {
    on: {
        [BlockTypeResource.anchorTarget]: {
            populate: '*',
        },
        [BlockTypeResource.blogOverview]: {
            populate: ['blogCategory', 'scheduling'],
        },
        [BlockTypeResource.blogsSelection]: {
            populate: ['blogs', 'blogs.image'],
        },
        [BlockTypeResource.brandCarousel]: {
            populate: [
                'brands',
                'brands.logo',
                'button',
                'button.link',
                'button.icon',
            ],
        },
        [BlockTypeResource.categoriesCarousel]: {
            populate: ['categories', 'categories.image', 'categories.lineImage'],
        },
        [BlockTypeResource.carousel]: {
            populate: ['images', 'scheduling'],
        },
        [BlockTypeResource.contentColumns]: {
            populate: [
                'columns',
                'columns.media',
                'columns.video.video',
                'columns.video.poster',
                'scheduling',
            ],
        },
        [BlockTypeResource.faq]: {
            populate: ['faqs', 'scheduling'],
        },
        [BlockTypeResource.featuredProducts]: {
            populate: [
                'product_selection',
                'button',
                'button.link',
                'button.icon',
            ],
        },
        [BlockTypeResource.form]: {
            populate: '*',
        },
        [BlockTypeResource.header]: {
            populate: [
                'autoplayMedia',
                'autoplayMedia.media',
                'link',
                'scheduling',
            ],
        },
        [BlockTypeResource.highlightedBlogPost]: {
            populate: ['blog', 'blog.image', 'scheduling'],
        },
        [BlockTypeResource.highlightedMedia]: {
            populate: [
                'autoplayMedia.media',
                'button',
                'button.link',
                'button.icon',
            ],
        },
        [BlockTypeResource.iconColumns]: {
            populate: ['columns', 'columns.icon', 'scheduling'],
        },
        [BlockTypeResource.iframe]: {
            populate: '*',
        },
        [BlockTypeResource.mediaBanner]: {
            populate: [
                'image.image',
                'video',
                'video.video',
                'video.poster',
                'link',
            ],
        },
        [BlockTypeResource.mediaGrid]: {
            populate: ['mediaItems', 'mediaItems.media', 'scheduling'],
        },
        [BlockTypeResource.newsletterCallToAction]: {
            populate: ['image', 'scheduling'],
        },
        [BlockTypeResource.productCollection]: {
            populate: [
                'productSelection',
                'button',
                'button.link',
                'button.icon',
                'media',
                'media.image',
                'media.image.image',
                'media.button',
                'media.button.link',
            ],
        },
        [BlockTypeResource.productOverview]: {
            populate: '*',
        },
        [BlockTypeResource.service]: {
            populate: '*',
        },
        [BlockTypeResource.uspSection]: {
            populate: [
                'uniqueSellingPoint',
                'uniqueSellingPoint.icon',
                'uniqueSellingPoint.link',
                'scheduling',
            ],
        },
    },
};

export const generatePaginatedDataQuery = (page: number, draftParams?: PageDraftConfig): string => {
    const pagination = {
        page,
        pageSize: 100,
    };

    return qs.stringify({
        ...draftParams,
        pagination,
    }, {
        encodeValuesOnly: true,
    });
};
